/**
 * Supporting Sections 1\u20135 of the homepage (Spec Section 3).
 * Each heading + body is locked verbatim copy from /lib/copy.js.
 *
 * Section 4's body slot is filled with the Privacy Version B reassurance
 * text. Section 5's body is the founder teaser \u2014 clicking it opens the
 * full founder story modal.
 */
import { SUPPORTING, PRIVACY } from "../lib/copy";
import { ShieldCheck, Eye, MessageCircle, Lock, BookOpen } from "lucide-react";

const ICONS = [
  <Eye className="w-5 h-5" strokeWidth={2.25} />,
  <ShieldCheck className="w-5 h-5" strokeWidth={2.25} />,
  <MessageCircle className="w-5 h-5" strokeWidth={2.25} />,
  <Lock className="w-5 h-5" strokeWidth={2.25} />,
  <BookOpen className="w-5 h-5" strokeWidth={2.25} />,
];

export const SupportingSections = ({ onOpenFounder }) => (
  <section
    data-testid="supporting-sections"
    className="px-5 sm:px-8 py-10 sm:py-14 max-w-3xl mx-auto"
  >
    <ol className="space-y-10 sm:space-y-12 list-none">
      {SUPPORTING.map((s, i) => {
        const isPrivacy = s.n === 4;
        const isFounder = s.n === 5;
        return (
          <li
            key={s.n}
            data-testid={`supporting-section-${s.n}`}
            className="grid grid-cols-[auto_1fr] gap-4 sm:gap-5 items-start"
          >
            <div
              className="w-10 h-10 rounded-xl flex items-center justify-center mt-1"
              style={{
                background: "var(--ss-card-2)",
                color: "var(--ss-gold-deep)",
                border: "1px solid var(--ss-rule-line)",
              }}
              aria-hidden
            >
              {ICONS[i]}
            </div>
            <div>
              <h2
                className="ss-display-tight text-2xl sm:text-3xl leading-tight mb-2"
                data-testid={`supporting-heading-${s.n}`}
                style={{ color: "var(--ss-ink)" }}
              >
                {s.heading}
              </h2>
              {isPrivacy ? (
                <p
                  className="text-base sm:text-lg leading-relaxed"
                  data-testid="supporting-privacy-body"
                  style={{ color: "var(--ss-ink-2)" }}
                >
                  {PRIVACY.B}
                </p>
              ) : isFounder ? (
                <p
                  className="text-base sm:text-lg leading-relaxed italic"
                  data-testid="supporting-founder-body"
                  style={{ color: "var(--ss-ink-2)" }}
                >
                  &ldquo;{s.body}&rdquo;{" "}
                  <button
                    type="button"
                    onClick={onOpenFounder}
                    data-testid="supporting-founder-link"
                    className="not-italic font-semibold underline-offset-2 hover:underline"
                    style={{ color: "var(--ss-gold-deep)" }}
                  >
                    Read the founder story →
                  </button>
                </p>
              ) : (
                <p
                  className="text-base sm:text-lg leading-relaxed"
                  data-testid={`supporting-body-${s.n}`}
                  style={{ color: "var(--ss-ink-2)" }}
                >
                  {s.body}
                </p>
              )}
            </div>
          </li>
        );
      })}
    </ol>
  </section>
);
